import { Model } from 'modules/core/lib/mobx-rest'

interface IPayrollDocument {
  id: number
  payroll_policy_period_id: number
  document_id: number
}

class PayrollDocument extends Model<IPayrollDocument> {
  static urlRoot() {
    return '/payroll/payroll_documents'
  }
}

export default PayrollDocument
